import { Address } from "store/apis/taxCalculator";
import { Countries } from "types/Models/countries";

type RawAddress = {
  street_address?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
  country?: string | null;
};

export const toTaxCalculatorAddress = (
  address: RawAddress | null | undefined,
  countriesData?: Countries[]
): Address | null => {
  // Nexus/compliance status only depends on the state — street/city/zip only
  // affect the precision of the calculated tax rate, so don't gate on those.
  if (!address?.state || !address?.country) {
    return null;
  }

  const countryCode = countriesData?.find(
    (country) => country.name === address.country
  )?.code_alpha_2;

  if (!countryCode) return null;

  return {
    address1: address.street_address || "",
    city: address.city || "",
    state: address.state,
    zipCode: address.zipcode || "",
    countryCode,
  };
};
